import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { LV2_PATHS } from '../navigation.constants';
import { queryParamsKeys } from '../query-param-key.contants';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  const currentUrl = state.url;

  return router.createUrlTree([`/${LV2_PATHS.LOGIN}`], {
    queryParams: { [queryParamsKeys.REDIRECT_URL_AFTER_LOGIN_SUCCESS]: currentUrl },
  });
};
